<template>
  <div class="special-coupon">
    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="
        () => {
          showPullRefreshLoading = false;
          toQueryChargeCouponList();
          toQueryUnPaidChargeCouponOrder();
        }
      "
    >
      <div class="special-coupon-page">
        <div class="special-coupon-page-bg" />
        <div style="position: relative; z-index: 2">
          <div class="special-coupon-page-header">
            <div class="account-wrap">
              <div class="account-wrap-title">充值账号</div>
              <div
                class="account-wrap-account"
                @click="handleAccountClick"
              >
                <span v-if="form.chargePhone">{{
                  formatPhone(form.chargePhone)
                }}</span>
                <span
                  class="account-value-tips"
                  v-else
                >请输入手机号</span>
                <img
                  class="account-wrap-icon"
                  src="@/assets/img/chargingVoucher/icon-edit-white.png"
                >
              </div>
            </div>
          </div>
          <div class="special-coupon-page-content">
            <div
              class="special-coupon-card"
              :class="{
                selected:
                  selectedSpecialPackage.specialPackageCode ===
                  item.specialPackageCode,
                disabled: !item.packageQuantity || item.packageQuantity === 0
              }"
              v-for="item in packageList"
              :key="item.specialPackageCode"
              @click="() => handleSelectSpecialPackage(item)"
            >
              <div class="special-coupon-card-title">
                {{ item.specialPackageName }}
              </div>
              <div class="special-coupon-card-info">
                <div class="special-coupon-value">{{ item.discountAmountYuan || 0 }}</div>
                <div class="special-coupon-price-wrap">
                  <img
                    class="special-coupon-price-img"
                    src="@/assets/img/chargingVoucher/icon-price-img.png"
                  >
                  <div class="special-coupon-price">
                    {{ Number(item.packageAmountYuan) || 0 }}元
                  </div>
                </div>
                <div class="special-coupon-type">{{ item.remark }}</div>
              </div>
              <div
                v-if="!!item.coupons.length"
                class="special-coupon-card-tags"
              >
                <div
                  class="special-coupon-card-tag"
                  v-for="coupon in item.coupons"
                  :key="coupon.specialPackageCode"
                >
                  {{ `${Number(coupon.productAmountYuan) || 0}元*${coupon.number || 0}张` }}
                </div>
              </div>
            </div>
            <div
              v-if="!packageList.length"
              class="coupons-blank"
            >
              <Blank text="暂无特惠券包" />
            </div>
          </div>
        </div>
        <div class="h-210" />
      </div>
    </van-pull-refresh>

    <div class="bottom-btn-wrap">
      <div
        v-if="haveWaitPayOrder"
        class="wait-pay-btn"
        @click="handleWaitPayBtnClick"
      >
        您有一笔待支付订单
      </div>
      <div class="coupon-provider-tips">
        <p>
          温馨提示：抵扣券有效期1个月，购买后不可退款和转让，过期自动作废，请根据需求购买。
        </p>
        <span
          class="link-text"
          @click="showCouponTips()"
        >更多说明</span>
      </div>
      <div class="buy-btn-wrap">
        <div class="buy-btn-value">
          <p>
            合计支付：
            <span>
              ￥ <i>{{ totalAmount }}</i>元
              <template v-if="canUseScore">
                或 <i>{{ totalScore }}</i>积分
              </template>
            </span>
          </p>
          <p>
            已优惠：<span>￥{{ discountAmountValue }}元</span>
          </p>
        </div>
        <div
          class="buy-btn"
          @click="handleBuyBtnClick"
        >立即支付</div>
      </div>
    </div>

    <!-- 待支付订单弹窗 -->
    <WaitPayPopup
      ref="refWaitPayPopup"
      :value="waitPayOrderInfo"
      @close="toQueryUnPaidChargeCouponOrder"
      @confirm="handleWaitPayConfirm"
      @cancel="handleWaitPayCancel"
    />
    <!-- 支付确认弹窗 -->
    <PayCheckPopup
      ref="refPayCheckPopup"
      :charge-number="form.chargePhone"
      provider-name="小桔充电"
      @confirm="handlePayCheckPopupConfirm"
      @cancel="handlePayCheckPopupCancel"
    />
    <!-- 支付结果弹窗 -->
    <PayResultPopup
      ref="refPayResultPopup"
      @confirm="toMyCouponsPage"
    />
    <!-- 输入弹窗 -->
    <InputPopup
      ref="refInputPopup"
      :min="1"
      @confirm="handleInputPopupConfirm"
    />
    <!-- 用券提示弹窗 -->
    <TipsBottomPopup ref="refTipsBottomPopup" />
    <!-- 提示弹窗 -->
    <TipsPopup
      ref="refTipsPopup"
      @confirm="(fn) => fn()"
      @close="toQueryUnPaidChargeCouponOrder"
    />
    <!-- 支付方式弹窗 -->
    <PayTypePopup
      ref="refPayTypePopup"
      :can-use-score="canUseScore"
      :pay-value="totalAmount"
      :pay-score="totalScore"
      @confirm="beforeToPrePay"
    />
  </div>
</template>

<script>
import WaitPayPopup from './components/WaitPayPopupSpecialCoupon.vue';
import PayCheckPopup from './components/PayCheckPopup.vue';
import PayResultPopup from './components/PayResultPopup.vue';
import InputPopup from './components/InputPopup.vue';
import TipsBottomPopup from './components/TipsBottomPopup.vue';
import TipsPopup from './components/TipsPopup.vue';
import PayTypePopup from './components/PayTypePopup.vue';
import Blank from './components/Blank.vue';
import {
  queryUnPaidChargeCouponOrder,
  cancelChargeCouponOrder,
  prePayChargeCouponOrder,
  queryDcjcSpecialList,
  createChargeCouponOrder,
  queryChargeCouponDetail
} from '@/common/api.js';
import Pay from '@/common/weixin.js';
import { REGEX_PHONE } from '@/common/regex';

class CreateForm {
  orderPhone = ''; // 下单账号手机
  chargePhone = ''; // 充值账号手机
  specialPackageCode = ''; // 特惠券包Code
  buyNum = 1; // 购买数量
  payAmountYuan = 0; // 支付金额（单位：元）
}

export default {
  name: 'SpecialCoupon',
  components: {
    WaitPayPopup,
    PayCheckPopup,
    PayResultPopup,
    InputPopup,
    TipsBottomPopup,
    TipsPopup,
    PayTypePopup,
    Blank
  },
  data() {
    return {
      // 表单
      form: new CreateForm(),
      // 是否显示下拉刷新
      showPullRefreshLoading: false,
      // 未支付订单信息
      waitPayOrderInfo: {},
      // 可使用积分
      canUseScore: 0,
      // 已选择的充电券
      selectedSpecialPackage: {},
      // 订单号
      orderNo: '',
      // 充电券列表
      packageList: [],
      // 支付方式
      chargePayType: 'WECHAT_PAY' // WECHAT_PAY 微信支付， SCORE_PAY 积分支付
    };
  },
  computed: {
    haveWaitPayOrder() {
      return !!this.waitPayOrderInfo.orderNo;
    },
    totalAmount() {
      return (
        Number(
          (
            this.form.buyNum * this.selectedSpecialPackage.discountAmountYuan || 0
          ).toFixed(2)
        ) || 0
      );
    },
    totalScore() {
      return (
        Number(
          (
            this.form.buyNum *
            this.selectedSpecialPackage.packageAmountYuan * 100 || 0
          ).toFixed(2)
        ) || 0
      );
    },
    discountAmountValue() {
      return (
        Number(
          (
            this.form.buyNum * this.selectedSpecialPackage.packageAmountYuan -
            this.form.buyNum * this.selectedSpecialPackage.discountAmountYuan || 0
          ).toFixed(2)
        ) || 0
      );
    }
  },
  created() {
    this.form.specialPackageCode = '';
    this.selectedSpecialPackage = {};
    this.toQueryChargeCouponList();
    this.toQueryUnPaidChargeCouponOrder();
  },
  mounted() {
    this.form.orderPhone = localStorage.getItem('_phone');
    this.form.chargePhone = localStorage.getItem('_chargePhone');

    let isCallBack = localStorage.getItem('_isCallBack') || '';
    let orderNo = localStorage.getItem('_orderNo') || '';
    if (isCallBack === 'undefined') {
      isCallBack = null;
      localStorage.removeItem('_isCallBack');
    }
    if (orderNo === 'undefined') {
      orderNo = null;
      localStorage.removeItem('_orderNo');
    }

    if (isCallBack && orderNo) {
      this.checkPay(orderNo);
    }
  },
  methods: {
    // 查询待支付订单
    toQueryUnPaidChargeCouponOrder() {
      const param = {
        chargeOrderModel: 'SPECIAL_PACKAGE'
      };
      queryUnPaidChargeCouponOrder(param).then((res) => {
        this.waitPayOrderInfo = res || {};
        console.log(this.waitPayOrderInfo);
      });
    },
    // 继续支付订单
    handleWaitPayConfirm() {
      wx.miniProgram.postMessage({
        data: {
          tips: '待支付订单刷新'
        }
      });

      if (this.chargePayType === 'WECHAT_PAY') {
        this.toPay(this.waitPayOrderInfo);
      } else {
        this.prePaySuccess();
      }
    },
    // 下单
    handleBuyBtnClick() {
      if (this.haveWaitPayOrder) {
        this.$refs.refTipsPopup.openPopup({
          text: '您有一笔订单暂未支付，请处理完毕后再支付新的订单。'
        });
        return;
      }
      if (!this.form.chargePhone) {
        this.$toast('请输入充值账号');
        return;
      }
      if (!REGEX_PHONE.test(this.form.chargePhone)) {
        this.$toast('充值账号应为有效手机号');
        return;
      }
      if (!this.form.specialPackageCode) {
        this.$toast('请选择充电券');
        return;
      }

      // 兼容旧有逻辑
      if (!this.form.orderPhone) {
        this.form.orderPhone = this.form.chargePhone;
      }
      this.$refs.refPayCheckPopup.openPopup();
    },
    // 去支付
    toPay(res) {
      this.form.specialPackageCode = '';
      this.selectedSpecialPackage = {};
      this.orderNo = res.orderNo;
      localStorage.setItem('_chargePhone', this.form.chargePhone);
      this.toPrePayChargeCouponOrder(res);
    },
    // 调用支付流程
    async toPrePayChargeCouponOrder(res) {
      const envMap = ['1', '1', '4'];
      // 调起预支付接口成功后
      try {
        this.$toast.loading({
          message: '支付中...',
          forbidClick: true,
          duration: 0
        });
        const prepayRs = await prePayChargeCouponOrder({
          payType: envMap[this.$browserEnv], // 支付环境
          orderNo: res.orderNo,
          openId: this.$route.query.openId || null,
          appCode: this.$route.query.appId || null
        });
        this.prePayHandle(prepayRs);
        this.$refs.refWaitPayPopup?.closePopup();
        this.$toast.clear();
      } catch (error) {
        console.log(error);
        this.toQueryUnPaidChargeCouponOrder();
      }
    },
    // 支付流程
    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayFail);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },
    // 支付成功
    prePaySuccess() {
      this.$refs.refPayResultPopup.openPopup(
        '充电券将在5分钟内发送到您的充值账户中，可前往目标充值账户中【我的充电券】页面查看购买的充电券。'
      );
      this.toQueryUnPaidChargeCouponOrder();
    },
    // 支付失败
    prePayFail() {
      this.$toast('支付失败');
      this.toQueryUnPaidChargeCouponOrder();
    },
    // 取消待支付订单
    handleWaitPayCancel() {
      const param = {
        orderNo: this.waitPayOrderInfo.orderNo
      };
      this.$toast.loading({
        message: '取消订单中...',
        forbidClick: true,
        duration: 0
      });
      cancelChargeCouponOrder(param).then((res) => {
        this.$toast('取消成功');
        this.toQueryChargeCouponList();
        this.toQueryUnPaidChargeCouponOrder();
        this.$refs.refWaitPayPopup.closePopup();
      });
    },
    // 查询充电券列表
    toQueryChargeCouponList() {
      const param = {
        agencyCode:
          '01c5123cff66c930c16d737cef6da57a7a2c927866808697037a63a5f9e85fd4',
        roteType: 'dcjc'
      };
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      queryDcjcSpecialList(param).then((res) => {
        if (res) {
          this.packageList = res.packageList || [];
          this.form.specialPackageCode = '';
          this.selectedSpecialPackage = {};
        }
        this.$toast.clear();
      });
    },
    // 支付方式确定
    handlePayCheckPopupConfirm() {
      this.$refs.refPayCheckPopup.closePopup();
      this.$nextTick(() => {
        if (this.canUseScore) {
          this.$refs.refPayTypePopup.openPopup();
        } else {
          this.beforeToPrePay('WECHAT_PAY');
        }
      });
    },
    // 去支付前
    beforeToPrePay(payType) {
      this.chargePayType = payType;
      this.toPrePay();
      this.$refs.refPayTypePopup.closePopup();
    },
    // 预支付，创建订单
    toPrePay() {
      const param = {
        ...this.form,
        chargePayType: this.chargePayType,
        payAmountYuan: Number(this.totalAmount),
        payScore: Number(this.totalScore),
        chargeOrderModel: 'SPECIAL_PACKAGE'
      };
      this.$toast.loading({
        message: '下单中...',
        forbidClick: true,
        duration: 0
      });
      createChargeCouponOrder(param, true)
        .then((res) => {
          if (res) {
            console.log('创建充电券订单成功');
            if (this.chargePayType === 'WECHAT_PAY') {
              this.toPay(res);
            } else {
              this.prePaySuccess();
            }
          }
          this.$toast.clear();
        })
        .catch((err) => {
          this.$toast.clear();
          const message = err?.data?.message || '';
          if (message.includes('购买数量上限')) {
            this.$refs.refTipsPopup.openPopup({
              text: message
            });
          } else {
            this.$toast(message);
          }
          this.toQueryUnPaidChargeCouponOrder();
        });
    },
    // 支付方式取消
    handlePayCheckPopupCancel() {
      this.$refs.refPayCheckPopup.closePopup();
      this.handleAccountClick();
    },
    // 修改充值账号
    handleAccountClick() {
      const param = {
        key: 'chargePhone',
        inputType: 'tel',
        text: '充值账号',
        value: this.form.chargePhone
      };
      this.$refs.refInputPopup.openPopup(param);
    },
    // 跳转我的充电券
    toMyCouponsPage() {
      if (this.$browserEnv == 0) {
        wx.miniProgram.switchTab({
          url: '/pages/chargingVoucher/my-coupons'
        });
      } else {
        this.$router.push({
          name: 'ChargingVoucherCenter',
          query: {
            nav: 'myCoupons'
          }
        });
      }
    },
    // 弹出输入弹窗
    handleInputPopupConfirm(param) {
      this.$refs.refInputPopup.closePopup();
      this.form[param.key] = param.value;
    },
    // 打开待支付弹窗
    handleWaitPayBtnClick() {
      this.$refs.refWaitPayPopup.openPopup();
    },
    // 展示提醒弹窗
    showCouponTips() {
      this.$refs.refTipsBottomPopup.openPopup({
        type: 'XIAOJU_PAY_OFF'
      });
    },
    // 格式化手机号
    formatPhone(val) {
      if (val) {
        const matches = /^(\d{3})(\d{4})(\d{4})$/.exec(val);
        if (matches) {
          return matches[1] + ' ' + matches[2] + ' ' + matches[3];
        }
        return val;
      }
    },
    // 选择特惠券包
    handleSelectSpecialPackage(item) {
      if (!item.packageQuantity || item.packageQuantity === 0) {
        this.$toast('券包已售罄，库存将在1天内补充');
        return;
      }

      if (
        this.selectedSpecialPackage.specialPackageCode ===
        item.specialPackageCode
      ) {
        this.form.specialPackageCode = '';
        this.selectedSpecialPackage = {};
      } else {
        this.form.specialPackageCode = item.specialPackageCode;
        this.selectedSpecialPackage = item;
      }
    },
    // 检查支付结果
    async checkPay(orderNo) {
      const param = {
        orderNo: orderNo
      };
      this.$toast.loading({
        message: '支付结果检查中...',
        forbidClick: true,
        duration: 0
      });
      queryChargeCouponDetail(param).then((res) => {
        if (res.orderStatus == 'PAID_WAIT') {
          this.prePayFail();
        } else {
          this.prePaySuccess();
          this.$toast.clear();
        }
        localStorage.removeItem('_isCallBack');
        localStorage.removeItem('_orderNo');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './styles/CharingCenter.scss';
@import './styles/specialCoupon.scss';

</style>
